import { DEFAULT_ENVIRONMENT, ITEM_NOT_FOUND_INDEX } from '@/utils/constants';

export function getDefaultEnvironment(
    environments: string[],
    defaultEnvironment: string = DEFAULT_ENVIRONMENT,
): string {
    if (environments.length === 0) return '';

    const index = environments.findIndex((env: string) => env === defaultEnvironment);
    if (index !== ITEM_NOT_FOUND_INDEX) {
        return environments[index];
    } else {
        const sortedEnvironments: string[] = [...environments].sort((a, b) => a.localeCompare(b));
        return sortedEnvironments[0];
    }
}
